import { DataViewBlockComponent } from './data-view-block';

export function effects() {
  customElements.define('hive-data-view', DataViewBlockComponent);
}
